import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Input, Button, Checkbox, Modal, DatePicker,Tooltip,Divider ,Icon} from "antd";
import {
  numberFormat,
  phoneNumFormat
} from "../../util";
import {
  SearchOutlined,LockOutlined
} from '@ant-design/icons';
import string from "../../string";
import { httpGet, httpUrl, httpPost, httpDownload } from "../../api/httpClient";
import SelectBox from "../../components/common/SelectBox";
import SelectBox2 from "../../components/common/SelectBox2";


const Search = Input.Search;
const RangePicker = DatePicker.RangePicker;

class MemberAccountWater extends Component {
  constructor(props) {
    super(props);
    this.state = {
     searchText:"",
     pagination:  {
        total: 0,
        current:0,
     },
     list: [],
    };
  }

  getUserAccountlist = (params = {}) => {
    let pageNum = params.pageNum || 1;
    const { searchText } = this.state
    httpGet(httpUrl.userAccountWaterList, [10, pageNum, searchText])
    .then(res => {
      const pagination = {...this.state.pagination}
      pagination.total = res.data.totalCount;
      this.setState({
        list: res.data.userAccountWaterList,
        pagination,
      })
    })
  }  

  
 componentDidMount() {
 this.getUserAccountlist();
}
onSearch = (value) => {
    this.setState(
      {
        searchText: value,
      },
      () => {
        this.getUserAccountlist({});

      }
    );
  };
  onUpdateStatus = (params) => {
    let self = this;
    let updateData = {
        acountSeq: params.acountSeq,
        userIdx: params.userIdx,
        status: params.status
    };
    let createData = {
        accountSeq: params.acountSeq,
        userIdx: params.userIdx,
        status: params.status
    }
    Modal.confirm({
      title: "입금처리",
      content: "해당 구좌를 입금완료 처리합니다.",
      okText: "확인",
      cancelText: " 취소",
      onOk() {
        httpPost(httpUrl.userAccountWaterUpdate, [], updateData)
          .then((res) => {          
            if (res.data === true) {
              Modal.info({
                title: "완료",
                content: "입금처리 되었습니다."
              })     
              self.getUserAccountlist({
                pageNum: self.state.pagination.current,
              });     
              // httpPost(httpUrl.playerboardCreate, [], createData)
              // .then((res) => {
                
              // })   
            } else {
              Modal.error({
                title: "오류",
                content: "오류가 발생했습니다. 관리자에게 문의해주세요."
              });
            }
          })
      }
    })
  };

handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager
    });
    this.getUserAccountlist({
      pageNum: pager.current,
    });
  };


  render() {
    const accountColumns = [             
      {
        title: "아이디",
        dataIndex: "userId",
        key: "userId",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },    
      {
        title: "이름",
        dataIndex: "userName",
        key: "userName",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },    
      {
        title: "휴대번호",
        dataIndex: "userPhone",
        key: "userPhone",     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
        <div>
         {data}
           </div>
        ),
      },    

      {
        title: "구좌번호",
        dataIndex: "acountSeq",
        key: "acountSeq",
     
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => (
          <div style={{fontSize:12.5}}>
         {data}
            {/* {data}▪<div><b>{row.recommendCode}</b></div> */}
          </div>
        )
      },    
      {
        title: "",
        dataIndex: "",
        key: "",
     
        className: "support-column-number fs-15 lh-21",
        render: (data, row, index) => (
         <div style={{fontSize:12.5}}>
        {row.status === 0 && (
        <Button
            onClick={() => {
                this.onUpdateStatus({
                    acountSeq: row.acountSeq,
                    userIdx: row.userIdx,
                    status: row.status
                })
            }}
        >입금처리</Button>
        )}
          {row.status === 1 && (
         <div>입금완료</div>
        )}
         </div>
          ),
      },                  
      
     
    ];


    return (
      <div className="flex-row flex-column">
       
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          <Divider orientation="left" style={{fontSize:21.5}}>구좌목록 </Divider>
          
        </div>
       
       

<div className="flex-row flex-center flex-end m-b-10">
  
           </div>
        <div className="flex-row flex-center m-b-10 flex-sb">
          <div className="flex-row flex-center">
           
          </div>
          
          <div className="flex-row flex-center">
          
            <label htmlFor="searchType">&nbsp;</label>     
            <Search
              placeholder={`아이디로 검색하세요.`}
              enterButton={<SearchOutlined/>}
              allowClear
              onSearch={this.onSearch}
              style={{ width: 400 }}
            />
          </div>
        </div>
        <Table
          id="account-table"
          className="flex-1"
          rowKey={(record) => record.idx}
          columns={accountColumns}
          dataSource={this.state.list}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        //   expandedRowRender={expandedRowRender}
          
        
        />
       
      </div>
    );
  }
}


export default MemberAccountWater;
